import { Component, EventEmitter, Input, Output } from '@angular/core';
import { INotificationItem } from '../../model/notification/notification-item.model';
import { UTILS } from '../../utils/methods/Utils';
import moment from 'moment';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss']
})
export class NotificationItemComponent {

  @Input()
  notification?: INotificationItem;

  @Input()
  isCompactMode = false;

  @Input()
  notificationOfMenu: boolean = true;


  @Output() clickNotification: EventEmitter<INotificationItem> = new EventEmitter<INotificationItem>();
  format = "shortTime";

  constructor(private readonly datePipe: DatePipe) { }

  getDate() {

    const { date } = this.notification!;

    const dateNew = new Date(date)

    const isToday = UTILS.isDateToday(dateNew.toISOString());

    return isToday
      ? this.getDifference(date)
      : this.datePipe.transform(date, 'dd MMM');
  }

  getDifference(date: Date) {

    const endTime = moment(new Date());
    const startTime = moment(date);

    let hoursDiff = endTime.diff(startTime, 'hours');
    let minutesDiff = endTime.diff(startTime, 'minutes');

    return hoursDiff === 0
      ? `${minutesDiff} min`
      : this.datePipe.transform(date, 'shortTime');

  }

  getLetters() {
    return UTILS.formatLettersNameUser(this.notification!.user!);
  }

  getTextReadClass() {
    return this.getBaseReadClass('text-blod');
  }

  getUnreadClass() {
    return this.getBaseReadClass('not-read');
  }


  private getBaseReadClass(unreadClass: string) {
    return this.notification!.alreadyRead ? '' : unreadClass;
  }

  onClickNotification(notification: INotificationItem) {
    this.clickNotification.emit(notification);
  }
}
